// react
import {createRef, lazy, Suspense, useMemo} from "react";
import {HashRouter, Route, Switch} from "react-router-dom";

// mui
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import {LocalizationProvider} from "@mui/lab";
import {ThemeProvider, useMediaQuery} from "@mui/material";

// date localization
import fr from "date-fns/locale/fr";

// Style
import theme from "@/theme";
import "@/App.css";
import "react-image-crop/dist/ReactCrop.css";


// Main components
import NotFoundPage from "@/components/NotFoundPage";
import {SnackbarProvider} from "notistack";

import Routes from "@/Routes";
import {LoaderProvider} from "@/components/common/ui/LoaderContext";
import {DisplayContext} from "@/components/common/ui/DisplayContext";


const FormTravellerInfo = lazy(() => import(/* webpackChunkName: "Traveller" */ "@/components/traveller-information/FormTravellerInfo"));

function App() {
    // add action to all snackbars
    const notistackRef = createRef();
    // const onClickDismiss = key => () => {
    //     notistackRef.current.closeSnackbar(key);
    // };
    const isDesktop = useMediaQuery("(min-width:900px)");

    const displayModes = useMemo(() => ({
        isDesktop: isDesktop,
        isMobile: !isDesktop,
    }), [isDesktop]);

    return (
        <DisplayContext.Provider value={displayModes}>
            <ThemeProvider theme={theme}>
                <LoaderProvider>
                    <LocalizationProvider dateAdapter={AdapterDateFns} locale={fr}>
                        <HashRouter basename={window._env_.REACT_APP_APPLICATION_SUB_PATH}>
                            <SnackbarProvider ref={notistackRef} dense={!isDesktop}>
                                <Suspense fallback={<div>Chargement...</div>}>
                                    <Switch>
                                        <Route path={Routes.TRAVELLER} component={FormTravellerInfo}/>
                                        <Route path="*" component={NotFoundPage}/>
                                    </Switch>
                                </Suspense>
                            </SnackbarProvider>
                        </HashRouter>
                    </LocalizationProvider>
                </LoaderProvider>
            </ThemeProvider>
        </DisplayContext.Provider>
    );
}

export default App;
